export default __webpack_public_path__ + "fc937b7ed4c6c316d21400e6f0a9d8db.svg";